export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20fashion%20product%20texture%20flat%20lay%20on%20warm%20cream%20surface%20sneakers%20accessories%20textile%20fabric%20gentle%20diffused%20shadows%20editorial%20style%20neutral%20beige%20sand%20tones%20subtle%20grain%20texture%20dreamy%20atmospheric%20quality%20abstract%20composition&width=1600&height=600&seq=cta-v2-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-background-50/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <div className="bg-background-50/80 backdrop-blur-sm rounded-3xl p-8 md:p-12">
          <div className="rounded-2xl overflow-hidden h-48 md:h-64 mb-8">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20curated%20fashion%20product%20photography%20collection%20on%20minimalist%20warm%20surface%20diverse%20sneakers%20hoodies%20and%20accessories%20artfully%20arranged%20in%20balanced%20composition%20soft%20natural%20lighting%20editorial%20quality%20clean%20aesthetic%20neutral%20cream%20ivory%20and%20sand%20background%20sophisticated%20lifestyle%20imagery&width=1000&height=500&seq=cta-v2-inner&orientation=landscape"
              alt="CSSBuy Spreadsheet"
              className="w-full h-full object-cover"
            />
          </div>

          <p className="font-heading text-xl md:text-2xl italic text-foreground-700 leading-relaxed">
            Envio seguro para o Brasil?
          </p>
          <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
            Taxas realmente baixas?
          </p>
          <p className="font-heading text-xl md:text-2xl italic text-foreground-700 mt-2">
            Suporte completo em português?
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center px-10 py-4 rounded-full bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            cssbuy sheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <p className="mt-4 text-xs text-foreground-400">Última atualização: 2026</p>
        </div>
      </div>
    </section>
  );
}